var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('PageTitle',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$store.state.app.pageName)}})]),_c('Customer',{attrs:{"groom-or-bride":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }